export default __webpack_public_path__ + "static/AntIcon40-c44ef005895d7d530e9e41cc6253006a.png";